import React from 'react';
import cn from 'classnames';
import Skeleton from '../../../ui/skeleton/Skeleton';

type Props = {
  wide: boolean
}

export default function CardSkeleton({wide}: Props) {
  return (
    <div className="px-4">
      <div className={cn('flex space-x-4')}>
        {wide &&
        <div className="flex-1 space-y-6">
          <div className="space-y-1">
            <Skeleton className="w-1/4"/>
            <Skeleton className="w-1/5"/>
          </div>
          <div className="flex flex-initial pt-5 justify-between">
            <Skeleton className="w-1/2"/>
            <Skeleton className="w-1/5"/>
          </div>
        </div>
        }
        {!wide &&
        <div className="flex-1 space-y-3">
          <div className="flex flex-initial justify-between">
            <div className="space-y-1 w-2/3">
              <Skeleton/>
              <Skeleton className="w-4/5"/>
            </div>
            <Skeleton className="w-1/4 h-12"/>
          </div>
          <div className="flex flex-initial pt-5 justify-between">
            <Skeleton className="w-4/12"/>
            <Skeleton className="w-2/12"/>
          </div>
        </div>
        }
      </div>
    </div>
  );
}
